// removed by extract-text-webpack-plugin
module.exports = {"mainSquare":"_2zSjsdSk_S4M8gJ5piBgih","smallSquare":"_33H7xJ1ViAC2of33qzWKCg","square1":"_1xajXPec9q6eonoCviyYV6 _33H7xJ1ViAC2of33qzWKCg","square2":"_2DUb6t-blFlxufyaE6tHwQ _33H7xJ1ViAC2of33qzWKCg","square3":"vZK1WuLe6R_Uw0KoSfC6B _33H7xJ1ViAC2of33qzWKCg","square4":"_12UV0cum4OE1GwpT5-_Zj- _33H7xJ1ViAC2of33qzWKCg"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Logo/style.css
// module id = 270
// module chunks = 0